var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalender(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14V12H13.5V14H11.5ZM7.5 14V12H9.5V14H7.5ZM15.5 14V12H17.5V14H15.5ZM11.5 18V16H13.5V18H11.5ZM7.5 18V16H9.5V18H7.5ZM15.5 18V16H17.5V18H15.5ZM3.5 22V4H6.5V2H8.5V4H16.5V2H18.5V4H21.5V22H3.5ZM5.5 20H19.5V10H5.5V20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalender);
export default __webpack_public_path__ + "static/media/calender.5931d57d26a886168fef2018169e0f43.svg";
export { ForwardRef as ReactComponent };